//old Code
const {
  REACT_APP_API_URL,
  REACT_APP_ENV,
  REACT_APP_USERSNAP_GLOBAL_API_KEY,
  REACT_APP_USERSNAP_PROJECT_API_KEY,
  REACT_APP_OKTA_ISSUER,
  REACT_APP_OKTA_CLIENT_ID,
} = process.env;

type config = {
  env: any;
  apiUrl: any;
  usersnapGlobalApiKey: any;
  usersnapProjectApiKey: any;
  OktaIssuer: any;
  OktaClientId: any;
};

export const _config: config = {
  env: REACT_APP_ENV,
  apiUrl: REACT_APP_API_URL,
  usersnapGlobalApiKey: REACT_APP_USERSNAP_GLOBAL_API_KEY,
  usersnapProjectApiKey: REACT_APP_USERSNAP_PROJECT_API_KEY,
  OktaIssuer: REACT_APP_OKTA_ISSUER,
  OktaClientId: REACT_APP_OKTA_CLIENT_ID,
};

export const saveConfigLocal = async () => {
  localStorage.setItem('CONFIG', JSON.stringify(_config));
};

export const getApiUrl = async () => {
  return _config.apiUrl;
};

/**
 * Gets the environment where the React app is running.
 *
 * @returns 'local', 'dev', or 'prod'
 */
export const getEnvironment = async () => {
  return _config.env;
};

export type UsersnapConfig = {
  globalApiKey: string;
  projectApiKey: string;
};

export const getUsersnapConfig = async (): Promise<UsersnapConfig> => {
  return {
    globalApiKey: _config.usersnapGlobalApiKey,
    projectApiKey: _config.usersnapProjectApiKey,
  };
};

let _uuid: string | undefined = undefined;

export const getUUID = () => {
  if (_uuid == undefined) {
    const storedPreference = localStorage.getItem('uuid');

    if (storedPreference && storedPreference != '') {
      _uuid = storedPreference;
    } else {
      _uuid = crypto.randomUUID();
      localStorage.setItem('uuid', _uuid);
    }
  }

  return _uuid;
};
